export const RAISED_CARD_CLASS = 'shadow-sm ring-foreground/5';
